import api from './api';
import type { Website } from '../types';

export const websiteService = {
  getWebsites: async () => {
    const response = await api.get('/api/websites');
    return response.data.data.websites as Website[];
  },

  getWebsite: async (id: string) => {
    const response = await api.get(`/api/websites/${id}`);
    return response.data.data.website as Website;
  },

  updateWebsite: async (id: string, data: Partial<Website>) => {
    const response = await api.patch(`/api/websites/${id}`, data);
    return response.data.data.website as Website;
  },
};
